import React from 'react'
import cx from 'classnames'

import { useAppSelector } from 'reduxTyped'
import { useTriggers } from 'apps/cms/components/Flows/components/FlowCard/components/Triggers/hooks/useTriggers/useTriggers'
import { contentManagementSelectors } from 'apps/cms/store'
import { FsFlow } from 'shared/api/requests/cms/schemas'

import cm from './components/Triggers/components/TriggerRow/TriggerRow.module.css'

interface ExternalFlowTriggersProps {
  triggers: FsFlow['triggers']
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void
}

export function ExternalFlowTriggers({ triggers, onClick }: ExternalFlowTriggersProps) {
  const isSearchMode = useAppSelector(contentManagementSelectors.getIsSearchMode)
  const { flowTriggers, maxVisibleTriggers } = useTriggers({ triggers })

  if (flowTriggers.length === 0) {
    return null
  }

  return (
    <div onClick={onClick}>
      {flowTriggers.slice(0, maxVisibleTriggers).map((trigger, index) => (
        <div
          key={index}
          className={cx(cm.triggerRow, {
            [cm.triggerRow_searchMode]: isSearchMode,
          })}
        >
          <div
            className={cx('d-flex align-start text-body-sm o-hidden', cm.triggerContent_fullWidth)}
          >
            <div className={cx(cm.triggerIcon, trigger.disabled && cm.disabled)}>
              {trigger.icon}
            </div>
            <div className={cx('o-hidden', cm.triggerName, trigger.disabled && cm.disabled)}>
              {trigger.title}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
